<template>
    <div>
        <video-player ref="videoPlayer"
            class="video-player vjs-custom-skin"
            :playsinline="true"
            :options="playerOptions"
            @ready="onPlayerReady"></video-player>
        <van-dialog v-model="showDialog"
            :show-confirm-button="false"
            :overlay="true"
            :lock-scroll="false">
            <img class="close-icon"
                src="static/image/closeIcon.png"
                alt=""
                @click="closeDialog()">
            <div class="dialog-title">视频下载</div>
            <div class="dialog-content">
                <div class="copy-tips">请复制视频链接到浏览器打开，进行下载。</div>
                <van-button v-clipboard:copy="filePath"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    plain
                    round
                    type="info"
                    class="copy-button">复制链接</van-button>

            </div>
        </van-dialog>
    </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player';

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import { Dialog, Toast, Button } from 'vant';
import { getEnvMark } from '../../../vibrantRubikCube/runtime/common-methods/utils.js';
import { EnvMark } from '../../../vibrantRubikCube/runtime/lucky-draw/common/global-variable.js';

export default {
  components: {
    videoPlayer,
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
  },
  props: {
    filePath: {
      type: String,
      default: '',
    },
    posterPath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度

        autoplay: false, //如果true,浏览器准备好时开始回放。

        muted: false, // 默认情况下将会消除任何音频。

        loop: true, // 导致视频一结束就重新开始。

        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）

        language: 'zh-CN',

        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

        sources: [
          {
            type: 'video/mp4',
            src: this.filePath, //视频url地址
          },
        ],

        poster: this.posterPath, // "https://hd-sit1.test.hihonor.com/accountzuul/integration/spuImage/miniImageLoad?url=marking/upload/2021-09-22/fc25b9c2a0074222983dbda80e43d548.png", //你的封面地址

        width: document.documentElement.clientWidth,

        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。

        controlBar: {
          timeDivider: true,

          durationDisplay: true,

          remainingTimeDisplay: false,

          fullscreenToggle: true, //全屏按钮
        },
      },
      env: '', // 当前打开环境
      showDialog: false,
    };
  },
  created() {
    this.env = sessionStorage.getItem('env') || getEnvMark();
  },
  mounted() {
    const CustomDownloadButton = this.createDownloadButton();
    videojs.registerComponent('downloadButton', CustomDownloadButton);
  },
  methods: {
    /**
     * 创建自定义下载按钮组件
     */
    createDownloadButton() {
      const DownloadButton = videojs.getComponent('Button');
      return videojs.extend(DownloadButton, {
        constructor: function (player, options) {
          DownloadButton.call(this, player, options);
          this.player = player;
          this.addClass('vjs-download-button'); // CSS类名
        },
        handleClick: () => {
          if ([EnvMark.wechatMp, EnvMark.alipayMp, EnvMark.wechatH5, EnvMark.alipayH5].includes(this.env)) {
            // 拉起引导弹窗
            this.openDialog();
          } else {
            // 直接下载
            const videoSrc = this.filePath;
            const link = document.createElement('a');
            link.href = videoSrc;
            link.download = 'video_' + Date.now() + '.mp4';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        },
      });
    },
    onPlayerReady(player) {
      // 注册自定义组件
      const CustomDownloadButton = this.createDownloadButton();
      player.getChild('controlBar').addChild(new CustomDownloadButton(player), {}, 9);
    },
    onCopy() {
      Toast('复制成功！');
    },
    onError(error) {
      Toast('复制失败！');
      console.log('复制失败', error);
    },
    handleStopTouchMove(e) {
      // 阻止弹窗出现时，页面穿透滚动
      e.preventDefault();
    },
    openDialog() {
      this.showDialog = true;
      window.addEventListener('touchmove', this.handleStopTouchMove, { passive: false });
    },
    closeDialog() {
      this.showDialog = false;
      window.removeEventListener('touchmove', this.handleStopTouchMove);
    },
  },
};
</script>


<style lang="scss">
.video-js .vjs-big-play-button {
  position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
}

/* 自定义下载按钮样式 */
.vjs-custom-skin .vjs-download-button {
  cursor: pointer;
  background: url('../../../../../static/image/download-icon.svg') no-repeat;
  width: 40px;
  height: 30px;
  background-size: 14px 14px;
  background-position: center;
}

/* 调整控件栏布局 */
.vjs-control-bar {
  display: flex !important;
  justify-content: space-between;
}
</style>
<style lang="scss" scoped>
.dialog-title {
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
  margin-top: 16px;
}
.dialog-content {
  padding: 32px;
  .copy-tips {
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: normal;
    color: #979797;
  }
}
.close-icon {
  width: 12px !important;
  height: 12px !important;
  right: 16px;
  top: 16px;
  position: absolute;
}
.copy-button {
  border-radius: 100px;
  background: #256fff;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  width: 100%;
  margin-top: 32px;
}
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/deep/.van-dialog {
  width: 86vw !important;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/themaic-video.vue